import "./ShopPageCard.css";

import React from "react";
import { useState, useRef } from "react";

import { Link } from "react-router-dom";

import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";

export const ShopPageCard = ({
  sizes,
  isOnSale,
  imgSrc1,
  imgSrc2,
  imgSrc3,
  imgSrc4,
  name,
  description,
  price,
  oldPrice,
  itemId,
  handleAddToCart,
  handleIsItemFocus,
}) => {
  let sizesAreAvailable = false;

  sizes.forEach((size) => {
    if (size.availableQuantity > 0) {
      sizesAreAvailable = true;
    }
  });
  const cardImgRef = useRef(null);
  const [imgsArray, setImgsArray] = useState([
    imgSrc1,
    imgSrc2,
    imgSrc3,
    imgSrc4,
  ]);
  const [itemImg1, setItemImg1] = useState(imgSrc1);
  const [itemImg2, setItemImg2] = useState(imgSrc2);
  const [itemImg3, setItemImg3] = useState(imgSrc3);
  const [itemImg4, setItemImg4] = useState(imgSrc4);

  const [selectedImg, setSelectedImg] = useState(0);

  const handleToImg1 = (e) => {
    cardImgRef.current.style.opacity = "0%";
    setTimeout(() => {
      setSelectedImg(0);
      cardImgRef.current.style.opacity = "100%";
    }, 400);
  };
  const handleToImg2 = (e) => {
    cardImgRef.current.style.opacity = "0%";
    setTimeout(() => {
      setSelectedImg(1);
      cardImgRef.current.style.opacity = "100%";
    }, 400);
  };
  const handleToImg3 = (e) => {
    cardImgRef.current.style.opacity = "0%";
    setTimeout(() => {
      setSelectedImg(2);
      cardImgRef.current.style.opacity = "100%";
    }, 400);
  };
  const handleToImg4 = (e) => {
    cardImgRef.current.style.opacity = "0%";
    setTimeout(() => {
      setSelectedImg(3);
      cardImgRef.current.style.opacity = "100%";
    }, 400);
  };

  const handleItemRedirect = () => {
    handleIsItemFocus(true);
  };

  const handleMoveToTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="shop-page-card-container">
      <div className="sale-sticker-container">
        {sizesAreAvailable === false ? (
          <p className="sale-sticker-notAvailable">ИЗЧЕРПАН !</p>
        ) : (
          <div></div>
        )}

        {isOnSale === true ? (
          <div className="sale-sticker-actual">ПРОМО !</div>
        ) : (
          <div></div>
        )}
      </div>

      <Link
        onClick={(handleItemRedirect, handleMoveToTop)}
        to={`/shop/item:${itemId}`}
        className="shop-card-image-container"
      >
        <img
          ref={cardImgRef}
          className="shop-card-image"
          src={imgsArray[selectedImg]}
          alt="Loading"
        ></img>
      </Link>
      <div className="shop-card-image-selectors-container">
        <img
          src={itemImg1}
          alt="Loading"
          className="shop-card-image-selectors-1"
          onClick={handleToImg1}
        />
        <img
          src={itemImg2}
          alt="Loading"
          className="shop-card-image-selectors-2"
          onClick={handleToImg2}
        />

        <img
          src={itemImg3}
          alt="Loading"
          className="shop-card-image-selectors-3"
          onClick={handleToImg3}
        />

        <img
          src={itemImg4}
          alt="Loading"
          className="shop-card-image-selectors-4"
          onClick={handleToImg4}
        />
      </div>
      <Link
        onClick={(handleItemRedirect, handleMoveToTop)}
        to={`/shop/item:${itemId}`}
        className="shop-card-name"
      >
        {name}
      </Link>
      <p className="shop-card-text">{description}</p>
      <p
        style={{ color: isOnSale === true ? "brown" : "rgb(41,41,41)" }}
        className="shop-card-price"
      >
        {isOnSale === true && (
          <p className="shop-card-old-price">{oldPrice}лв.</p>
        )}
        {price}лв.
      </p>
      <Link
        to={`/shop/item:${itemId}`}
        onClick={(handleItemRedirect, handleMoveToTop)}
        className="shop-card-button"
      >
        <ShoppingCartIcon sx={{ fontSize: "16px" }} />
        <p className="shop-card-button-text">добави</p>
      </Link>
    </div>
  );
};
